/**************************************************
 * Nombre:       Formulario_Reserva_Check_In
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {BadgeOutlined, ChildCare, Person, PointOfSaleOutlined} from "@mui/icons-material";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import IngresoFecha from "../../../Modulo_formularios/Componentes/IngresoFecha";
import {Tarjeta_Descuento} from "../../Tarjetas/Tarjeta_Descuento";
import Formulario_Reserva_CheckIn_Acompanante from "./Formulario_Reserva_CheckIn_Acompanante";
import {Tarjeta_Adicional_Acompanante} from "../../Tarjetas/Tarjeta_Adicional_Acompanante";

const Formulario_Reserva_Check_In = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        dato: 'acompanantes',
        nombre: 'Agregar Acompañante',
        Formulario: Formulario_Reserva_CheckIn_Acompanante,
        Tarjeta: Tarjeta_Adicional_Acompanante,
    })


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoFecha Icono={PointOfSaleOutlined} nombre={'Fecha de Ingreso'} dato={'fechaOcupacion'}
                                  editable={false} {...props} />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num Id Principal'} dato={'cc'} {...props}
                        editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={Person} nombre={'Num Acompañante'} dato={'numAcompanantes'}
                                  type={'numero'} {...props}  editable={false} />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={ChildCare} nombre={'Num Niños'} dato={'numNinos'}
                                  type={'numero'} {...props}   editable={false}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Datos Acompañantes</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresarObjeto/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Notas Internas</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto nombre={'Notas Internas'} dato={'notas'} {...props}
                                  lineas={6}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Reserva_Check_In